import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import {
  GetSubgroupsRequest,
  GetSubgroupsResponse,
  SaveSubgroupRequest,
  SaveSubgroupResponse,
  Subgroup,
  UpdateSubgroupPositionRequest,
} from '@models'

@Injectable({
  providedIn: 'root',
})
export class SubgroupService {
  private readonly baseUrl = `${environment.api.baseUrl}/product-structure/v1/sub-groups`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetSubgroupsRequest): Promise<GetSubgroupsResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.groupId) httpParams = httpParams.set('groupId', params.groupId)

      if (params.name) httpParams = httpParams.set('name', params.name)
    }

    const response = await firstValueFrom(this.http.get<GetSubgroupsResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<Subgroup> {
    const response = await firstValueFrom(this.http.get<Subgroup>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveSubgroupRequest): Promise<SaveSubgroupResponse> {
    const response = await firstValueFrom(this.http.post<SaveSubgroupResponse>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveSubgroupRequest): Promise<SaveSubgroupResponse> {
    const response = await firstValueFrom(this.http.put<SaveSubgroupResponse>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }

  async updatePosition(payload: UpdateSubgroupPositionRequest[]): Promise<void> {
    const response = await firstValueFrom(this.http.patch<void>(`${this.baseUrl}/position`, payload))
    return response
  }
}
